import type { Socket } from 'socket.io-client';
import type { ServerToClientEvents, ClientToServerEvents } from '../shared/events.js';

type AppSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

declare const window: Window & {
  __godbeySocket?: {
    create: (opts?: {
      onConnect?: (s: AppSocket) => void;
      onDisconnect?: (reason: string) => void;
      onConnectError?: (err: Error) => void;
      onIdentity?: (data: { playerName: string; isAdmin: boolean; playerId?: string }) => void;
      errorEvent?: string;
      onError?: (data: { message: string }) => void;
    }) => AppSocket;
    reconnectWithFreshAuth: () => void;
  };
};

let socket!: AppSocket;

export function initSocket(opts?: {
  onIdentity?: (data: { playerName: string; isAdmin: boolean; playerId?: string }) => void;
}): AppSocket {
  if (!window.__godbeySocket) {
    throw new Error('sso-socket.js not loaded — include https://godbey.games/js/sso-socket.js');
  }
  socket = window.__godbeySocket.create({
    errorEvent: 'game:error',
    onError: (data) => alert(data.message),
    onIdentity: opts?.onIdentity,
    // Connection errors are transient and socket.io retries them itself. The
    // shared wrapper puts a "retrying" overlay up; an alert here interrupted
    // the game with a raw "websocket error" and read as a crash.
  });
  return socket;
}

export function getSocket(): AppSocket {
  return socket;
}

export function reconnectWithFreshAuth(): void {
  window.__godbeySocket?.reconnectWithFreshAuth();
}
